<div class="cmps-cdk-d-flex cmps-cdk-flex-column cmps-cdk-h-100p">
    <div class="cmps-cdk-d-flex cmps-cdk-flex-grow-1 cmps-cdk-overflow-hidden">
        <div
            class="cmps-transcript-dialog-notes-page--content cmps-transcript-dialog-notes-page--half-page cmps-cdk-overflow-y-auto"
            [class.cmps-cdk-flex-50]="
                _formHasNotes || _service.state?.summaryEnabled === true
            "
            [class.cmps-cdk-mr-0dot5]="
                _formHasNotes || _service.state?.summaryEnabled === true
            "
            [class.cmps-cdk-flex-100]="
                !_formHasNotes && _service.state?.summaryEnabled != true
            "
        >
            <div class="cmps-cdk-mb-1">
                <cmps-transcript-dialog-focus></cmps-transcript-dialog-focus>
            </div>
            <ng-container *ngTemplateOutlet="descTpl"></ng-container>
            <div
                class="justify-content-between cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-mb-0dot5"
            >
                <div class="cmps-cdk-d-flex cmps-cdk-align-items-center">
                    <button
                        class="cmps-icon-button--no-bg"
                        cmpsIconButton
                        [cmpsOverlayTrigger]="filterTpl"
                    >
                        <span cmpsIconButtonLabel>
                            {{ _i18n._7360_FILTER | translate }}
                        </span>
                        <cmps-icon svgIcon="filter-outline"></cmps-icon>
                    </button>
                    <button
                        class="cmps-icon-button--no-bg"
                        cmpsIconButton
                        [cmpsTooltipTrigger]="_i18n._9665_RESET | translate"
                        (click)="_onResetClick()"
                    >
                        <cmps-icon svgIcon="reload"></cmps-icon>
                    </button>
                </div>
                <div>
                    <button
                        class="cmps-cdk-border-color-grey-400 cmps-cdk-color-grey-400 not:disabled:hover:cmps-cdk-bg-color-grey-400 not:disabled:focus:cmps-cdk-bg-color-grey-400 not:disabled:hover:cmps-cdk-color-white not:disabled:focus:cmps-cdk-color-white not:disabled:hover:cmps-cdk-pseudo-child not:disabled:focus:cmps-cdk-pseudo-child"
                        cmpsOutlineButton
                        (click)="_descVisible = true"
                        *ngIf="
                            _service.state?.hasDesc !== true && !_descVisible
                        "
                    >
                        <span cmpsOutlineButtonLabel>
                            {{ _i18n._11209_ADD_DESCRIPTION | translate }}
                        </span>
                        <!-- TODO fix cmpsOutlineButton so that cmps-cdk-fill-* can go on <button> -->
                        <cmps-icon
                            class="cmps-cdk-fill-grey-400 not:disabled:hover:cmps-cdk-fill-white not:disabled:focus:cmps-cdk-fill-white"
                            svgIcon="plus"
                        ></cmps-icon>
                    </button>
                </div>
            </div>
            <div>
                <table class="table table-hover table-centered mb-0">
                    <thead class="table-primary">
                        <tr>
                            <th class="grid-tbl-header">
                                <cmps-checkbox
                                    class="check-all"
                                    [checked]="
                                        _service.state?.allQuotesAreSelected ??
                                        false
                                    "
                                    (change)="_onSelectAllQuotesClick()"
                                >
                                </cmps-checkbox>
                            </th>
                            <th
                                *ngIf="
                                    _service.state?.transcript?.transcriptId !=
                                    null
                                "
                                class="grid-tbl-header"
                            >
                                {{ _i18n._966_TIME | translate }}
                            </th>
                            <th class="grid-tbl-header">
                                {{ _i18n._102_USER_NAME | translate }}
                            </th>
                            <th class="grid-tbl-header">
                                {{ _i18n._9982_CONVERSATION | translate }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container
                            *ngIf="
                                _service.state?.transcript?.transcriptId ==
                                    null ||
                                !(_service.state?.filteredQuotes?.length > 0)
                            "
                        >
                            <tr>
                                <td
                                    class="text-center td4"
                                    colspan="4"
                                >
                                    {{
                                        _i18n._10051_NO_TRANSCRIPTS_AVAILABLE
                                            | translate
                                    }}
                                </td>
                            </tr>
                        </ng-container>
                        <ng-container
                            *ngIf="
                                _service.state?.transcript?.transcriptId != null
                            "
                        >
                            <tr
                                (click)="_onQuoteCheckboxChange(line)"
                                *ngFor="
                                    let line of _service.state?.filteredQuotes;
                                    let i = index
                                "
                            >
                                <td class="td1">
                                    <cmps-checkbox
                                        [checked]="
                                            _service.state
                                                ?.filteredQuotesSelectedLookup?.[
                                                i
                                            ]
                                        "
                                        (change)="_onQuoteCheckboxChange(line)"
                                        (click)="
                                            $event.stopImmediatePropagation()
                                        "
                                    >
                                    </cmps-checkbox>
                                </td>
                                <td class="td2">
                                    {{ line?.endTime | cmpsDate: 'h:mm:ss' }}
                                </td>
                                <td class="td3">
                                    {{
                                        line?.userName ?? line?.msftDisplayName
                                    }}
                                </td>
                                <td class="td4">
                                    {{ line?.quote }}
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </div>
        <div
            class="cmps-transcript-dialog-notes-page--content cmps-transcript-dialog-notes-page--half-page cmps-cdk-flex-50 cmps-cdk-ml-0dot5 cmps-cdk-overflow-y-auto"
            *ngIf="_formHasNotes || _service.state?.summaryEnabled === true"
        >
            <div [formGroup]="_form">
                <div
                    class="note-box cmps-cdk-mb-1"
                    *ngIf="_validFocusWarning"
                >
                    <div
                        class="d-inline-flex align-items-center flex-grow-1 alert-warning-compas"
                    >
                        <cmps-icon svgIcon="alert"></cmps-icon>
                        <div class="h6 m-0 ml-2 text-white">
                            {{
                                _i18n._9507_A_COMMITMENT_CANNOT_BE_CREATED_UPDATED_WITHOUT_A_FOCUS_
                                    | translate
                            }}
                        </div>
                    </div>
                </div>
                <div>
                    <div
                        class="cmps-cdk-mb-1"
                        *ngIf="_formHasCommitmentNotes === true"
                    >
                        <cmps-transcript-dialog-focus
                            [forNotes]="true"
                        ></cmps-transcript-dialog-focus>
                    </div>
                    <div
                        class="cmps-cdk-mb-1"
                        *ngIf="_service.state?.summaryEnabled === true"
                    >
                        <cmps-transcript-dialog-summary
                            (summaryChange)="_summary = $event"
                        ></cmps-transcript-dialog-summary>
                    </div>
                    <div
                        cmpsNotes
                        formControlName="commitmentNotes"
                        [config]="_service.state.noteEntity"
                        [defaultCategory]="_NoteCategory.GENERAL"
                        [hasTagBar]="false"
                        [hasCategoryBar]="false"
                        [cmpsFormControlPath]="[]"
                        [showHeader]="true"
                    ></div>
                    <div
                        cmpsNotes
                        formControlName="observationNotes"
                        [config]="_service.state.noteEntity"
                        [hasCategoryBar]="true"
                        [defaultCategory]="_NoteCategory.GENERAL"
                    ></div>
                </div>
            </div>
        </div>
    </div>
    <div class="cmps-cdk-d-flex cmps-cdk-mt-1">
        <div
            [class.cmps-cdk-flex-50]="
                _formHasNotes || _service.state?.summaryEnabled === true
            "
            [class.cmps-cdk-mr-0dot5]="
                _formHasNotes || _service.state?.summaryEnabled === true
            "
            [class.cmps-cdk-flex-100]="
                !_formHasNotes && _service.state?.summaryEnabled != true
            "
        >
            <div class="justify-content-between cmps-cdk-d-flex">
                <div>
                    <button
                        class="cmps-cdk-bg-color-red-100"
                        cmpsButton
                        [disabled]="
                            !(_service.state.selectedQuotes?.length > 0)
                        "
                        (click)="_onDeleteQuotesClick()"
                        *ngIf="_service.state?.allowedActions?.deleteQuotes"
                    >
                        <cmps-icon svgIcon="delete"></cmps-icon>
                        <span cmpsButtonLabel>{{
                            _i18n._11029_DELETE_CONVERSATION | translate
                        }}</span>
                    </button>
                </div>
                <div>
                    <button
                        class="cmps-cdk-border-color-blue-100 cmps-cdk-color-blue-100 not:disabled:hover:cmps-cdk-bg-color-blue-100 not:disabled:focus:cmps-cdk-bg-color-blue-100 not:disabled:hover:cmps-cdk-color-white not:disabled:focus:cmps-cdk-color-white not:disabled:hover:cmps-cdk-pseudo-child not:disabled:focus:cmps-cdk-pseudo-child"
                        cmpsOutlineButton
                        [disabled]="
                            !(_service.state.selectedQuotes?.length > 0)
                        "
                        (click)="_onCopyToClipboardClick()"
                    >
                        <!-- TODO fix cmpsOutlineButton so that cmps-cdk-fill-* can go on <button> -->
                        <cmps-icon
                            class="cmps-cdk-fill-blue-100 not:disabled:hover:cmps-cdk-fill-white not:disabled:focus:cmps-cdk-fill-white"
                            svgIcon="content-copy"
                        ></cmps-icon>
                        <span cmpsOutlineButtonLabel>{{
                            _i18n._9983_COPY | translate
                        }}</span>
                    </button>
                    <button
                        class="cmps-cdk-ml-0dot5"
                        cmpsButton
                        [disabled]="
                            !(_service.state.selectedQuotes?.length > 0) ||
                            _formHasObservationNotes === true
                        "
                        (click)="_onCreateCommitmentNoteClick()"
                    >
                        <cmps-icon svgIcon="plus"></cmps-icon>
                        <span cmpsButtonLabel>{{
                            _i18n._9488_ADD_COMMITMENT_NOTE | translate
                        }}</span>
                    </button>
                    <button
                        class="cmps-cdk-ml-0dot5"
                        cmpsButton
                        [disabled]="
                            !(_service.state.selectedQuotes?.length > 0) ||
                            _formHasCommitmentNotes === true
                        "
                        (click)="_onCreateObservationNoteClick()"
                    >
                        <cmps-icon svgIcon="plus"></cmps-icon>
                        <span cmpsButtonLabel>{{
                            _i18n._11032_ADD_OBSERVATION_NOTE | translate
                        }}</span>
                    </button>
                </div>
            </div>
        </div>
        <div
            class="cmps-cdk-flex-50 cmps-cdk-ml-0dot5"
            *ngIf="_formHasNotes || _service.state?.summaryEnabled === true"
        >
            <div class="cmps-cdk-d-flex cmps-cdk-justify-content-flex-end">
                <button
                    class="cmps-cdk-ml-0dot5 cmps-cdk-border-color-red-100 cmps-cdk-color-red-100 not:disabled:hover:cmps-cdk-bg-color-red-100 not:disabled:focus:cmps-cdk-bg-color-red-100 not:disabled:hover:cmps-cdk-color-white not:disabled:focus:cmps-cdk-color-white not:disabled:hover:cmps-cdk-pseudo-child not:disabled:focus:cmps-cdk-pseudo-child"
                    cmpsOutlineButton
                    [disabled]="!_formHasNotes"
                    (click)="_onRemoveAllNotesClick()"
                    *ngIf="_formHasNotes"
                >
                    <!-- TODO fix cmpsOutlineButton so that cmps-cdk-fill-* can go on <button> -->
                    <cmps-icon
                        class="cmps-cdk-fill-red-100 not:disabled:hover:cmps-cdk-fill-white not:disabled:focus:cmps-cdk-fill-white"
                        svgIcon="cancel"
                    ></cmps-icon>
                    <span cmpsOutlineButtonLabel>{{
                        _i18n._9990_REMOVE_ALL_NOTES | translate
                    }}</span>
                </button>
                <button
                    class="cmps-cdk-ml-0dot5 cmps-cdk-bg-color-green-100"
                    cmpsButton
                    (click)="_onOpenNewObservationClick()"
                    *ngIf="_formHasObservationNotes === true"
                >
                    <cmps-icon svgIcon="note-plus-outline"></cmps-icon>
                    <span cmpsButtonLabel>{{
                        _i18n._9984_CREATE_NEW_OBSERVATION | translate
                    }}</span>
                </button>
                <button
                    class="cmps-cdk-ml-0dot5 cmps-cdk-bg-color-green-100"
                    cmpsButton
                    (click)="_onPublishClick()"
                    *ngIf="_formHasCommitmentNotes === true"
                >
                    <cmps-icon svgIcon="note-plus-outline"></cmps-icon>
                    <span cmpsButtonLabel>{{
                        _i18n._9415_PUBLISH | translate
                    }}</span>
                </button>
            </div>
        </div>
    </div>
</div>

<ng-template #descTpl>
    <div
        class="cmps-transcript-dialog-notes-page--desc cmps-cdk-mb-1"
        *ngIf="_service.state?.hasDesc === true || _descVisible"
    >
        <div
            class="cmps-transcript-dialog-notes-page--desc-header justify-content-between cmps-cdk-d-flex cmps-cdk-px-0dot5 cmps-cdk-py-0dot25"
        >
            <div class="cmps-cdk-d-flex cmps-cdk-align-items-center">
                <div class="cmps-cdk-font-bold">
                    {{ _i18n._9301_DESCRIPTION | translate }}
                </div>
            </div>
            <div>
                <button
                    cmpsCardIconButton
                    (click)="_descExpanded = !_descExpanded"
                >
                    <cmps-icon
                        [svgIcon]="_descExpanded ? 'minus' : 'plus'"
                    ></cmps-icon>
                </button>
            </div>
        </div>
        <cmps-comment
            [placeholder]="_i18n._10017_ENTER_DESCRIPTION | translate"
            [disabled]="!_service.state?.allowedActions?.editTranscript"
            [ngModel]="_service.state?.transcript?.description"
            [ngModelOptions]="{ updateOn: 'blur' }"
            (ngModelChange)="_onDescriptionChange($event)"
            *ngIf="_descExpanded"
        ></cmps-comment>
    </div>
</ng-template>

<ng-template
    let-overlay="overlay"
    #filterTpl
>
    <cmps-filter [overlay]="overlay">
        <cmps-filter-category-header>
            {{ _i18n._9681_PARTICIPANTS | translate }}
        </cmps-filter-category-header>
        <cmps-filter-category-body>
            <button
                class="cmps-transcript-dialog-notes-page--participant"
                cmpsButton
                (click)="_onFilterParticipantClick(null)"
            >
                <span cmpsButtonLabel>
                    {{ _i18n._10057_ALL_PARTICIPANTS | translate }}
                </span>
            </button>
            <ng-container
                *ngFor="let p of _service.state?.transcript?.participants"
            >
                <button
                    class="cmps-transcript-dialog-notes-page--participant"
                    cmpsButton
                    (click)="_onFilterParticipantClick(p)"
                >
                    <span cmpsButtonLabel>
                        {{ p?.userName ?? p?.msftDisplayName }}
                    </span>
                </button>
            </ng-container>
        </cmps-filter-category-body>

        <cmps-filter-category-header>
            {{ _i18n._710_SEARCH | translate }}
        </cmps-filter-category-header>
        <cmps-filter-category-body>
            <div class="cmps-form-input-group">
                <input
                    class="cmps-form-input"
                    [ngModel]="_service.state?.filterOpts?.keyword ?? ''"
                    (ngModelChange)="_onKeywordFilterChange($event)"
                />
                <button
                    class="cmps-button--sm cmps-cdk-min-w-auto"
                    cmpsButton
                >
                    <span cmpsButtonLabel>
                        {{ _i18n._710_SEARCH | translate }}
                    </span>
                </button>
            </div>
        </cmps-filter-category-body>

        <cmps-filter-category-header>
            {{ _i18n._966_TIME | translate }}
        </cmps-filter-category-header>
        <cmps-filter-category-body>
            <div class="cmps-transcript-dialog-notes-page--custom-ngx-slider">
                <!--value/highValue only seem to reset when using two-way data-binding-->
                <ngx-slider
                    [(value)]="_sliderValue"
                    [(highValue)]="_sliderHighValue"
                    [options]="_sliderOptions"
                    (userChange)="_onSliderValueChange($event)"
                >
                </ngx-slider>
            </div>
        </cmps-filter-category-body>
    </cmps-filter>
</ng-template>
